__turbopack_context__.v({
  "animate-in-nav-item": "SubNav-module-scss-module__xwvkHW__animate-in-nav-item",
  "aspectBox": "SubNav-module-scss-module__xwvkHW__aspectBox",
  "buttonCircle": "SubNav-module-scss-module__xwvkHW__buttonCircle",
  "fade-in": "SubNav-module-scss-module__xwvkHW__fade-in",
  "icon": "SubNav-module-scss-module__xwvkHW__icon",
  "isEntered": "SubNav-module-scss-module__xwvkHW__isEntered",
  "isExited": "SubNav-module-scss-module__xwvkHW__isExited",
  "isExiting": "SubNav-module-scss-module__xwvkHW__isExiting",
  "item": "SubNav-module-scss-module__xwvkHW__item",
  "itemActive": "SubNav-module-scss-module__xwvkHW__itemActive",
  "label": "SubNav-module-scss-module__xwvkHW__label",
  "menu": "SubNav-module-scss-module__xwvkHW__menu",
  "menuCurrentTitle": "SubNav-module-scss-module__xwvkHW__menuCurrentTitle",
  "menuCurrentTitleSeparator": "SubNav-module-scss-module__xwvkHW__menuCurrentTitleSeparator",
  "menuTitle": "SubNav-module-scss-module__xwvkHW__menuTitle",
  "menuTrigger": "SubNav-module-scss-module__xwvkHW__menuTrigger",
  "root": "SubNav-module-scss-module__xwvkHW__root",
  "rootInner": "SubNav-module-scss-module__xwvkHW__rootInner",
});
